import type { OrderDetailRawResp } from 'shared/infra';
import type { SubstitutionFlowStatus } from 'shared/domain';

export const ORDER_DETAIL_API_PATH = Object.freeze({
  READ_ORDER_DETAIL_BY_ID:
    'api/rs-aliados-gateway/orders/partner/status/orders/:orderId',
} as const);

export const SUBSTITUTION_FLOW_STATUS_MAP: Record<
  NonNullable<OrderDetailRawResp['substitution_flow_state']>['status'],
  SubstitutionFlowStatus
> = {
  awaiting_action: 'awaiting',
  timeout: 'timeout',
  another_option_selected: 'another',
  accepted: 'accepted',
  refused: 'refused',
  in_support_chat: 'chat',
} as const;
